import React from 'react'
import {
  RegisterOptions,
  useController,
  useFormContext
} from 'react-hook-form'

import Dropdown, {DropdownProps} from '../dropdown/Dropdown'

export interface FormDropdownProps
  extends Omit<DropdownProps, 'selectedValue' | 'setSelectedValue'> {
  name: string;
  rules?: Omit<
  RegisterOptions,
  'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >;
}

export const ControlledFormRadioInput = ({
  name,
  rules,
  ...rest
}: FormDropdownProps) => {
  const methods = useFormContext()

  const {field} = useController({
    name,
    control: methods.control,
    rules
  })

  return (
    <Dropdown
      {...rest}
      setSelectedValue={field.onChange} // send value to hook form
      selectedValue={field.value} // input value
    />
  )
}

export default ControlledFormRadioInput
